const FILL = 'fill';
const SIGN_UP = 'signUp';

export const RequestSubtypes = Object.freeze({
    [FILL]: 0,
    [SIGN_UP]: 1,
});

export const RequestSubtypeNames = Object.freeze({
    0: FILL,
    1: SIGN_UP,
});
